import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payment-gateway-selector"
export default class extends Controller {
  static targets = ["stripeRadio", "mercadoPagoRadio", "stripeConfig", "mercadoPagoConfig", "stripeOption", "mercadoPagoOption"]

  connect() {
    console.log("PaymentGatewaySelector connected")
    console.log("Stripe radio target:", this.hasStripeRadioTarget)
    console.log("MercadoPago radio target:", this.hasMercadoPagoRadioTarget)
    this.updateDisplay()
  }

  selectStripe() {
    console.log("selectStripe called")
    if (this.hasStripeRadioTarget) {
      this.stripeRadioTarget.checked = true
      this.updateDisplay()
    }
  }

  selectMercadoPago() {
    console.log("selectMercadoPago called")
    if (this.hasMercadoPagoRadioTarget) {
      this.mercadoPagoRadioTarget.checked = true
      this.updateDisplay()
    }
  }

  updateDisplay() {
    console.log("updateDisplay called")

    const isStripeSelected = this.hasStripeRadioTarget && this.stripeRadioTarget.checked
    const isMercadoPagoSelected = this.hasMercadoPagoRadioTarget && this.mercadoPagoRadioTarget.checked

    console.log("Stripe selected:", isStripeSelected)
    console.log("MercadoPago selected:", isMercadoPagoSelected)

    // Show/hide config panels
    if (this.hasStripeConfigTarget) {
      this.stripeConfigTarget.style.display = isStripeSelected ? 'block' : 'none'
    }
    if (this.hasMercadoPagoConfigTarget) {
      this.mercadoPagoConfigTarget.style.display = isMercadoPagoSelected ? 'block' : 'none'
    }

    // Update option card styling
    if (this.hasStripeOptionTarget) {
      this.stripeOptionTarget.classList.toggle('border-fitcloud-coral', isStripeSelected)
      this.stripeOptionTarget.classList.toggle('bg-fitcloud-mint/50', isStripeSelected)
      this.stripeOptionTarget.classList.toggle('border-gray-300', !isStripeSelected)
    }

    if (this.hasMercadoPagoOptionTarget) {
      this.mercadoPagoOptionTarget.classList.toggle('border-fitcloud-coral', isMercadoPagoSelected)
      this.mercadoPagoOptionTarget.classList.toggle('bg-fitcloud-mint/50', isMercadoPagoSelected)
      this.mercadoPagoOptionTarget.classList.toggle('border-gray-300', !isMercadoPagoSelected)
    }
  }
}
